export const ANALYTICS_WRAPPER_CLASS = 'search-results-analytics-container';
export const ANALYTICS_SECTION_CLASS = 'search-results-analytics-section';
export const ANALYTICS_RESULT_CLASS = 'search-result-analytics-result';
